import axios from "axios";

const organization_id = localStorage.getItem("organization_id");
const session_id = localStorage.getItem("session_id");

// Detect current hostname
const hostname = window.location.hostname;
// API config based on hostname
let baseURL = "";
if (hostname === "localhost" || hostname === "127.0.0.1") {
  // Local development
  baseURL = "http://localhost:8000";
  // baseURL = "https://evaluation-api.apeejay.edu";
} else if (hostname === "43.204.137.210") {
  // IP-based server
  baseURL = "http://43.204.137.210:8090";
} else if (hostname.includes("apeejay.edu")) {
  // Production domain
  baseURL = "https://evaluation-api.apeejay.edu";
} else {
  // Default fallback (optional)
  baseURL = "http://43.204.137.210:8090";
}

// Set axios defaults
axios.defaults.baseURL = `${baseURL}/api/v1`;
axios.defaults.headers.common["Content-Type"] = "application/json";
axios.defaults.headers.common["organization-id"] = organization_id;
axios.defaults.headers.common["session-id"] = session_id;

export default baseURL;
